import React from 'react'

import ImpactWidget from './ImpactWidget'

const ImpactContent = props => {
  const widgets = props.widgets.map((widget, i) =>
    <ImpactWidget key={widget.token} {...widget}
      iconClassName={
        [ 0, 9 ].indexOf(i) > -1
        ? 'impact-widget-lg-icon' // 'h3'
        : ''
      }
      titleClassName={
        [ 0, 9 ].indexOf(i) > -1
        ? 'impact-widget-lg-title' // 'display-4 mt-4'
        : ''
      }
      descClassName={
        [ 0, 9 ].indexOf(i) > -1
        ? 'impact-widget-lg-desc' // 'lead'
        : ''
      }
    />
  )

  return (
    <div className={`impact-page-inner ${props.status}`}>
      <div className="row mx-0 flex-fill text-white">
        <div className="col-md-6 px-0 d-flex">{widgets[0]}</div>
        <div className="col-md-6 px-0 d-flex">
          <div className="row mx-0 flex-fill">
            <div className="col-sm-6 col-md-12 col-lg-6 px-0 d-flex">{widgets[1]}</div>
            <div className="col-sm-6 col-md-12 col-lg-6 px-0 d-flex">{widgets[2]}</div>
            <div className="col-sm-6 px-0 d-flex d-md-none d-lg-flex">{widgets[3]}</div>
            <div className="col-sm-6 px-0 d-flex d-md-none d-lg-flex">{widgets[4]}</div>
          </div>
        </div>
        <div className="col-md-12 px-0 d-none d-md-flex d-lg-none">
          <div className="row mx-0 flex-fill">
            <div className="col-sm-6 px-0 d-flex">{widgets[3]}</div>
            <div className="col-sm-6 px-0 d-flex">{widgets[4]}</div>
            <div className="col-sm-6 px-0 d-flex">{widgets[5]}</div>
            <div className="col-sm-6 px-0 d-flex">{widgets[6]}</div>
          </div>
        </div>
        <div className="col-md-6 px-0 d-flex">
          <div className="row mx-0 flex-fill">
            <div className="col-sm-6 px-0 d-flex d-md-none d-lg-flex">{widgets[5]}</div>
            <div className="col-sm-6 px-0 d-flex d-md-none d-lg-flex">{widgets[6]}</div>
            <div className="col-sm-6 col-md-12 col-lg-6 px-0 d-flex">{widgets[7]}</div>
            <div className="col-sm-6 col-md-12 col-lg-6 px-0 d-flex">{widgets[8]}</div>
          </div>
        </div>
        <div className="col-md-6 px-0 d-flex">{widgets[9]}</div>
      </div>
    </div>
  )
}

export default ImpactContent
